import React, { useMemo, useState } from 'react';
import { connect, useIntl } from 'umi';
import { gameInfoType } from '@op/types/common';
import { Layout, Tabs } from 'tea-component';
import { PAGE_NAME } from '@op/constants/page';
import ContentBody from '@op/components/ContentBody';
import SameStartDate from './SameStartDate';
import DifferentStartDate from './DifferentStartDate';
import { useInitBuriedPointInfo } from '@op/operationLog/buriedPoint';
import CompareSameStartDatePoint from '@op/operationLog/pages/CompareSameStartDate';
import CompareDifferentDatePoint from '@op/operationLog/pages/CompareDifferentDate';

const { Content } = Layout;
function Compare({
  gameInfo,
  userInfo,
  wholeGameInfo,
}: {
  gameInfo: gameInfoType;
  userInfo: any;
  wholeGameInfo: any;
}) {
  const { formatMessage } = useIntl();
  const [activeId, setActiveId] = useState('sameStartDate');

  useInitBuriedPointInfo({
    buriedPoint:
      activeId === 'differentStartDate'
        ? CompareDifferentDatePoint
        : CompareSameStartDatePoint,
  });

  const onActive = (tab: { id: any }) => {
    setActiveId(tab.id);
  };
  const tabs = useMemo(
    () => [
      {
        id: 'sameStartDate',
        label: formatMessage({
          id: 'Same Start Date (Including Align to Release)',
        }),
      },
      {
        id: 'differentStartDate',
        label: formatMessage({
          id: 'Different Start Date (For Event Analysis)',
        }),
      },
    ],
    [formatMessage],
  );

  return (
    <Content className="dbo-competitor">
      <ContentBody
        pageName={PAGE_NAME.COMPARE}
        contentHeard={
          <Content.Header
            title={formatMessage({ id: 'Compare-1' })}
            className="dbo-header contentHead-normal"
          >
            {/* 注释 tab 也要 去掉  dbo-header后面 contentHead-normal 类名  */}
            <div className="header-tab">
              <Tabs
                ceiling
                tabs={tabs}
                animated={false}
                activeId={activeId}
                onActive={onActive}
              />
            </div>
          </Content.Header>
        }
      >
        {activeId === 'sameStartDate' ? (
          <SameStartDate
            gameInfo={gameInfo}
            userInfo={userInfo}
            wholeGameInfo={wholeGameInfo}
          ></SameStartDate>
        ) : (
          <DifferentStartDate gameInfo={gameInfo}></DifferentStartDate>
        )}
      </ContentBody>
    </Content>
  );
}

export default connect((state: { opinionCommon: any; home: any }) => {
  const { opinionCommon, home } = state;

  return {
    gameInfo: opinionCommon.gameInfo,
    wholeGameInfo: opinionCommon.wholeGameInfo,
    userInfo: home.userInfo,
  };
})(Compare);
